import type {
  StandardVoucherTopCandidate,
  VoucherBannerVariant
} from '../VoucherBanner.types'

interface ResolveStandardVoucherTopCandidateInput {
  isEligible: boolean
  page: string | null
  amount: number | null
  variant: VoucherBannerVariant
  isActivated: boolean
}

export const resolveStandardVoucherTopCandidate = ({
  isEligible,
  page,
  amount,
  variant,
  isActivated
}: ResolveStandardVoucherTopCandidateInput): StandardVoucherTopCandidate => {
  // `reason` values below are for observability only (e.g. tracking/debugging
  // why the banner is hidden) and do not drive any control logic.
  if (amount === null) return { kind: 'hidden', reason: 'flow-ineligible' }
  if (!isEligible) return { kind: 'hidden', reason: 'flow-ineligible' }

  if (page === 'contact') {
    return { kind: 'standard-contact-prompt', amount, variant }
  }

  if (isActivated) {
    return { kind: 'standard-activated', amount, variant }
  }

  return { kind: 'hidden', reason: 'activation-required' }
}
